var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['rounded-full px-3 py-1 text-xs font-medium', _vm.typeClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }